import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-business-segment-form',
    templateUrl: './business-segment-form.component.html',
    styleUrls: ['./business-segment-form.component.less'],
    standalone: false
})
export class BusinessSegmentFormComponent implements OnInit {

  constructor( private formBuilder: FormBuilder,
            @Inject(MAT_DIALOG_DATA) public data: any,
            private dailogRef : MatDialogRef<BusinessSegmentFormComponent>,
            private service:DataService,
            private utilityService: UtilityService,
            private dailog:MatDialog,
            private router:Router,private logger:NGXLogger,
            private permissionService:PermissionService) 
            { this.dailogRef.disableClose=true; }

  businessSegmentForm:FormGroup;
  showStatus:string;
  showDeactivateToggle=false;
  showReactivateToggle=false;
  checked:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  editPermission:boolean=false;
  isEditedData:boolean=false;
  disableSubmit:boolean=false;
  viewLog = this.formBuilder.control(false);

  ngOnInit(): void {
    this.viewLog.setValue(false);
    this.getAllPermissions();
    this.initializeForm();
    this.patchValue();
  }

  private initializeForm() {
    this.businessSegmentForm = this.formBuilder.group({
      id: [],
      name: [],
      code: [],
      status: [],
      active: [],
      parentId:[],
      reactivate: [],
      deactivate: []
    });
  }
  
  private openDailog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });
  
    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.BUSINESS_SEGMENT_LIST]);
            this.dailogRef.close();
          }
          else{
            this.saveBusinessSegment();
          }
        }
    })
  }
  
  public cancel() {
    if(this.businessSegmentForm.dirty){
      this.isEditedData=false;
      this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
    }
    else{
      this.router.navigate([APP_ROUTES.BUSINESS_SEGMENT_LIST]);
      this.dailogRef.close();
    }
  }
  
  public save() {  
    this.businessSegmentForm.markAllAsTouched();
    if(this.businessSegmentForm.valid){
      this.isEditedData=true;
      if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
      }
      else {
        this.openDailog(Message.SAVE_OPEN_DAILOG);
      }  
    }
  }
  
  saveBusinessSegment(){
    this.businessSegmentForm.markAllAsTouched();
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.businessSegmentForm.valid){
      this.logger.info('Business Segment Form Value',this.businessSegmentForm.value);
      this.service[method](Api.BUSINESS_SEGMENT, this.businessSegmentForm.value).subscribe(res => {
        this.utilityService.notifier(`Business Segment ${message} successfully`, 'success');
        this.router.navigate([APP_ROUTES.BUSINESS_SEGMENT_LIST]);
        this.dailogRef.close();
      });
    }
  }
  
  openDeactivateForm(e:MatSlideToggleChange){
      let data={id:this.id.value,message:'Business Segment',api:Api.DEACTIVATE_BUSINESS_SEGMENT,route:APP_ROUTES.BUSINESS_SEGMENT_LIST}
      const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(value => {
        this.checked = !this.checked;
    })
  }
  
  openReactivateForm(e:MatSlideToggleChange){
    let data={id:this.id.value,message:'Business Segment',api:Api.REACTIVATE_BUSINESS_SEGMENT,route:APP_ROUTES.BUSINESS_SEGMENT_LIST}
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
    })
  }

  private patchValue() {
    if (this.data?.id) {
        this.showStatus = this.getStatus(this.data);
        this.businessSegmentForm.patchValue(this.data);
        if(this.data.submittedForApproval || this.data.status==='DEACTIVATED'){
          this.disableSubmit=true;
          this.businessSegmentForm.disable();
        }
    }
  }

  private getStatus(data: any) {
      if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
          this.showDeactivateToggle=true;
          return null;
      }
      else if (data.status == "DEACTIVATED" && !data.submittedForApproval && this.reactivatePermission) {
          this.showReactivateToggle=true;
          return "Deactivated...";
      } else {
          return this.utilityService.getApprovalMessage({status:data.status,
            submittedForApproval: data.submittedForApproval,
            deactivationWefDate: data.detactivate?.deactivationWefDate,
            reactivationWefDate: data.reactivate?.reactivationWefDate});
      }
    }

  public getAllPermissions(){
    let permissionCodes=[PermissionKey.BUSINESS_SEGMENT_REACTIVATE_PERMISSION,PermissionKey.BUSINESS_SEGMENT_DEACTIVATE_PERMISSION,PermissionKey.BUSINESS_SEGMENT_EDIT_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.BUSINESS_SEGMENT);
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BUSINESS_SEGMENT_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BUSINESS_SEGMENT_DEACTIVATE_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.BUSINESS_SEGMENT_EDIT_PERMISSION})?.show?true:false;
  }

  get name(){ return this.businessSegmentForm.get('name'); }
  get code(){ return this.businessSegmentForm.get('code'); }
  get status(){ return this.businessSegmentForm.get('status'); }
  get id(){ return this.businessSegmentForm.get('id'); }
}
